module.exports = __webpack_public_path__ + "static/media/bgAdv2.4b4fe4a1.jpg";